import { Card, CardContent } from "@/components/ui/card";
import { HeartPulse, Smile, Activity, Info } from "lucide-react";
import { Tooltip, TooltipTrigger, TooltipContent, TooltipProvider } from "@/components/ui/tooltip";

const ICONS = {
  shi: HeartPulse,
  shes: Smile,
  hhar: Activity,
};
const ACCENTS = {
  shi: "bg-sky-50 text-sky-700 border-sky-200",
  shes: "bg-amber-50 text-amber-700 border-amber-200",
  hhar: "bg-emerald-50 text-emerald-700 border-emerald-200",
};

export function CompositeMetricCards({ composite }) {
  if (!composite) return null;
  return (
    <div className="grid grid-cols-1 md:grid-cols-3 gap-4" data-testid="composite-metric-cards">
      {["shi", "shes", "hhar"].map((k) => {
        const cm = composite[k];
        if (!cm) return null;
        const Icon = ICONS[k];
        return (
          <Card key={k} data-testid={`composite-${k}`} className="p-5">
            <div className="flex items-start justify-between mb-3">
              <div className={`w-11 h-11 rounded-xl grid place-items-center border ${ACCENTS[k]}`}>
                <Icon className="w-5 h-5" />
              </div>
              <TooltipProvider>
                <Tooltip>
                  <TooltipTrigger asChild>
                    <button className="text-slate-400 hover:text-slate-600" aria-label={`About ${cm.label}`}>
                      <Info className="w-4 h-4" />
                    </button>
                  </TooltipTrigger>
                  <TooltipContent className="max-w-xs">
                    <div className="font-semibold mb-1">{cm.label} ({cm.short})</div>
                    <div className="text-xs">{cm.description}</div>
                  </TooltipContent>
                </Tooltip>
              </TooltipProvider>
            </div>
            <div className="text-[10px] uppercase tracking-widest text-slate-400 font-bold">{cm.short}</div>
            <div className="font-heading font-bold text-3xl text-slate-900 mt-1">
              {cm.score}
              <span className="text-lg text-slate-400 ml-1">{cm.unit}</span>
            </div>
            <div className="text-xs text-slate-500 mt-1">{cm.label}</div>
            <div className="mt-4 pt-3 border-t border-slate-100 space-y-1.5">
              {cm.components.map((c) => (
                <div key={c.label} className="flex items-center justify-between text-xs">
                  <span className="text-slate-500 truncate mr-2">{c.label}</span>
                  <span className="font-mono tabular-nums font-semibold text-slate-800 shrink-0">{c.value}{cm.unit}</span>
                </div>
              ))}
            </div>
          </Card>
        );
      })}
    </div>
  );
}
